import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationOptions } from 'react-query';

import useAPIMutation from '../api/useAPIMutation';
import { JobPostingDetail } from '../types';
import useUpdateVacancyMutation from './useUpdateVacancyMutation';

interface ProfileMutationVariables {
  jobPostingId: JobPostingDetail['id'];
  functionId: number;
}

const useProfileMutation = (
  options?: Omit<
    UseMutationOptions<
      AxiosResponse<JobPostingDetail, unknown>,
      AxiosError<unknown, unknown>,
      ProfileMutationVariables,
      unknown
    >,
    'mutationFn'
  >
) => {
  const updateVacancyMutation = useUpdateVacancyMutation();

  return useAPIMutation(async ({ jobPostingId, functionId }: ProfileMutationVariables) => {
    return updateVacancyMutation.mutateAsync({
      jobPostingId,
      jobPostingFields: {
        function_id: functionId,
      },
    });
  }, options);
};

export default useProfileMutation;
